import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, Clock, Mail, User, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export const PendingApproval = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const registrationData = location.state || {};

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="relative z-10 w-full max-w-2xl">
        <div className="glass-card p-8 md:p-12 text-center animate-in fade-in-0 slide-in-from-bottom-4">
          {/* Success Icon */}
          <div className="mb-6 inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-500/20 border-2 border-green-500">
            <CheckCircle className="w-10 h-10 text-green-500" />
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Registration Successful!
          </h1>

          {/* Subtitle */}
          <div className="flex items-center justify-center gap-2 mb-6">
            <Clock className="w-5 h-5 text-yellow-500 animate-pulse" />
            <p className="text-xl text-yellow-400 font-semibold">
              Waiting for Admin Approval
            </p>
          </div>

          {/* Info Box */}
          <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-6 mb-8 text-left">
            <p className="text-slate-300 text-lg mb-4">
              Thank you for registering! Your account has been created and is currently pending approval.
            </p>

            {registrationData.email && (
              <div className="space-y-3 mb-4">
                <div className="flex items-center gap-3 text-slate-300">
                  <Mail className="w-5 h-5 text-blue-400" />
                  <span className="font-medium">{registrationData.email}</span>
                </div>
                {registrationData.name && (
                  <div className="flex items-center gap-3 text-slate-300">
                    <User className="w-5 h-5 text-green-400" />
                    <span className="font-medium">{registrationData.name}</span>
                  </div>
                )}
              </div>
            )}

            <div className="border-t border-slate-700 pt-4 mt-4">
              <p className="text-slate-400 text-sm mb-3">
                <strong className="text-white">What happens next?</strong>
              </p>
              <ol className="list-decimal list-inside space-y-2 text-slate-400 text-sm">
                <li>An administrator will review your registration</li>
                <li>You'll receive approval (typically within 24-48 hours)</li>
                <li>Once approved, you can log in with your credentials</li>
                <li>You'll have access to the platform based on your role</li>
              </ol>
            </div>
          </div>

          {/* Important Notice */}
          <div className="bg-blue-900/30 border border-blue-700 rounded-lg p-4 mb-6">
            <p className="text-blue-200 text-sm">
              💡 <strong>Important:</strong> Please do not attempt to log in until you receive approval. 
              Your login will not work until an administrator approves your account.
            </p>
          </div>

          {/* Action Button */}
          <Button
            onClick={() => navigate('/')}
            className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 px-8 py-6 text-lg"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Return to Login
          </Button>

          {/* Contact Info */}
          <p className="text-slate-500 text-sm mt-6">
            Need help? Contact your administrator for assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
